import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanAirPathMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/air-path-menu/floorplan-air-path-menu.component";
import { FloorplanAlarmDeviceMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/alarm-device-menu/floorplan-alarm-device-menu.component";
import { FloorplanDimensionsMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/dimensions-menu/floorplan-dimensions-menu/floorplan-dimensions-menu.component";
import { FgdsProductSearchMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/fgds-product-search-menu/fgds-product-search-menu.component";
import { FloorplanFlameDetectorMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-flame-detector-menu/floorplan-flame-detector-menu.component";
import { FloorplanMenuType, LocalizeFloorplanMenuTypePipe } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-type";
import { FloorplanGasWarningCenterMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/gas-warning-center-menu/floorplan-gas-warning-center-menu.component";
import { GroupMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/group-menu/group-menu.component";
import { FloorplanImageMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/image-menu/floorplan-image-menu.component";
import { FloorplanMainMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/main-menu/floorplan-main-menu.component";
import { FloorplanPlasticSignMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/plastic-sign-menu/floorplan-plastic-sign-menu.component";
import { FloorplanSignalMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/signal-menu/floorplan-signal-menu.component";
import { FloorplanTransmitterMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/transmitter-menu/floorplan-transmitter-menu.component";
import { FloorplanWiringMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/wiring-menu/floorplan-wiring-menu.component";
import { FloorplanZoneMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/zone-menu/floorplan-zone-menu.component";
import { CentralStationMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/central-station-menu/central-station-menu.component";
import { DisplayMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/display-menu/display-menu.component";
import { FloorplanMonitoringZoneMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/floorplan-monitoring-zone-menu/floorplan-monitoring-zone-menu.component";
import { KvmMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/kvm-menu/kvm-menu.component";
import { MonitoringProductSearchMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/monitoring-product-search-menu/monitoring-product-search-menu.component";
import { PatientMonitorMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/patient-monitor-menu/patient-monitor-menu.component";
import { TelemetryMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/telemetry-menu/telemetry-menu.component";
import { UtilityMenuComponent } from "@project/floorplanner/floorplan-menu/monitoring/utility-menu/utility-menu.component";
import { FloorplanAnnotationMenuComponent } from "./fgds/floorplan-text-menu/floorplan-annotation-menu.component";

@Component({
  selector: "app-floorplan-menu-item",
  templateUrl: "./floorplan-menu-item.component.html",
  styleUrls: ["./floorplan-menu-item.component.scss"],
  imports: [
    UiKitModule,
    FloorplanAirPathMenuComponent,
    FloorplanAlarmDeviceMenuComponent,
    FloorplanGasWarningCenterMenuComponent,
    FloorplanImageMenuComponent,
    FloorplanMainMenuComponent,
    FloorplanAnnotationMenuComponent,
    FloorplanWiringMenuComponent,
    FloorplanPlasticSignMenuComponent,
    FloorplanSignalMenuComponent,
    FloorplanTransmitterMenuComponent,
    FloorplanFlameDetectorMenuComponent,
    FloorplanZoneMenuComponent,
    LocalizeFloorplanMenuTypePipe,
    FgdsProductSearchMenuComponent,
    GroupMenuComponent,
    FloorplanDimensionsMenuComponent,
    FloorplanMonitoringZoneMenuComponent,
    MonitoringProductSearchMenuComponent,
    PatientMonitorMenuComponent,
    CentralStationMenuComponent,
    TelemetryMenuComponent,
    KvmMenuComponent,
    DisplayMenuComponent,
    UtilityMenuComponent,
  ],
  standalone: true,
})
export class FloorplanMenuItemComponent {
  @Input({ required: true }) activeFloorplan!: Floorplan;
  @Input({ required: true }) menuType!: FloorplanMenuType;
  @Output() close$ = new EventEmitter();

  protected readonly FloorplanMenuType = FloorplanMenuType;

  onClose() {
    this.close$.emit();
  }
}
